import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import { history } from '../../configuration/store';
import { Login, ChangePassword, ForgotPassword, ResetPassword, AcceptInvite, AcceptWitnessInvite } from './forms';
import { login, changePassword, forgotPassword, resetPassword } from './../../reducers/identity';
import { acceptInvite } from './../../reducers/invites';
import { parseQueryString } from '../../utilities/string';

import './account.css';
import { RoleDefinitions } from '../../utilities/roles';

class AccountPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = { form: undefined };

        this.renderForm = this.renderForm.bind(this);
        this.getAcceptInviteHeading = this.getAcceptInviteHeading.bind(this);
    }

    renderForm(inviteInfo = undefined) {
        let form = this.state.form ? this.state.form : this.props.form;
        const { login, changePassword, forgotPassword, resetPassword, acceptInvite, session } = this.props;
        const inviteId = inviteInfo && inviteInfo.invite;
        let links = {
            login: (
                <div className="link" onClick={() => history.push('/login')}>
                    <FormattedMessage id={'goToLogin'} defaultMessage={'Login'} />
                </div>
            ),
            forgot: (
                <div className="link" onClick={() => history.push('/forgot')}>
                    <FormattedMessage id={'goToForgotPassword'} defaultMessage={'Forgot password'} />
                </div>
            )
        };

        switch (form) {
            case 'change-password':
                // TODO: remove
                return (
                    <div>
                        <div className="form-group">
                            <FormattedMessage id={'introText.changePassword'} defaultMessage={'Please change your temporary password before proceeding.'} />
                        </div>
                        <ChangePassword onSubmit={values => changePassword({ ...values, session })} />
                    </div>
                );

            case 'forgot':
                return (
                    <div>
                        <ForgotPassword onSubmit={values => forgotPassword(values, () => history.push('/reset'))} />
                        <div className="account-links">{links.login}</div>
                    </div>
                );

            case 'reset':
                return session ? (
                    <div>
                        <ResetPassword onSubmit={values => resetPassword({ ...values, session }, () => history.push('/login'))} />
                        <div className="account-links">{links.login}</div>
                    </div>
                ) : (
                    <div>
                        <ForgotPassword onSubmit={values => forgotPassword(values, () => history.push('/reset'))} />
                        <div className="account-links">{links.login}</div>
                    </div>
                );

            case 'accept-invite':
                const { location } = this.props;
                if (!location || !location.search) {
                    return (
                        <div>
                            <Login onSubmit={login} /> <div className="account-links">{links.forgot}</div>
                        </div>
                    );
                } else if (inviteInfo && inviteInfo.invitee_role === 'witness') {
                    return (
                        <AcceptWitnessInvite
                            onSubmit={values =>
                                login(
                                    values,
                                    {
                                        onNewPasswordNeeded: data => {
                                            changePassword({ ...values, session: data }, () => {
                                                acceptInvite(inviteId, () => login({ ...values }));
                                            });
                                        }
                                    },
                                    true
                                )
                            }
                            initialValues={parseQueryString(location.search)}
                        />
                    );
                } else {
                    return (
                        <AcceptInvite
                            onSubmit={values =>
                                login(
                                    values,
                                    {
                                        onNewPasswordNeeded: data => {
                                            changePassword({ ...values, password: values.newPassword, session: data }, () => {
                                                acceptInvite(inviteId, () => login({ ...values, password: values.newPassword }));
                                            });
                                        }
                                    },
                                    true
                                )
                            }
                            initialValues={parseQueryString(location.search)}
                        />
                    );
                }

            case 'login':
            default:
                return (
                    <div>
                        <Login onSubmit={login} /> <div className="account-links">{links.forgot}</div>
                    </div>
                );
        }
    }

    getAcceptInviteHeading(inviteInfo) {
        if (!inviteInfo) {
            return null;
        }

        const { invitee_role, admin_name, inviter_resource_name, invitee_resource_name, is_new } = inviteInfo;
        switch (invitee_role) {
            case RoleDefinitions.Admin.type:
            case RoleDefinitions.AdminHumanResources.type:
            case RoleDefinitions.AdminFinance.type:
                return <FormattedMessage id={'acceptInviteHeadingAdmin'} defaultMessage={'You have an account on {admin}'} values={{ admin: admin_name }} />;

            case RoleDefinitions.Client.type:
                return is_new === 'true' ? (
                    <FormattedMessage
                        id={'acceptInviteHeadingNewClient'}
                        defaultMessage={'Set up {company} on {admin}'}
                        values={{ company: invitee_resource_name, admin: admin_name }}
                    />
                ) : (
                    <FormattedMessage
                        id={'acceptInviteHeadingCommon'}
                        defaultMessage={'Join {company} on {admin}'}
                        values={{ company: invitee_resource_name, admin: admin_name }}
                    />
                );

            case RoleDefinitions.Witness.type:
                return (
                    <FormattedMessage
                        id={'acceptInviteHeadingWitness'}
                        defaultMessage={'Witness an I9 for {company} on {admin}'}
                        values={{ company: inviter_resource_name, admin: admin_name }}
                    />
                );

            case RoleDefinitions.ClientTimesheetApprover.type:
            case RoleDefinitions.ClientHiringManager.type:
            case RoleDefinitions.Contractor.type:
            default:
                return (
                    <FormattedMessage
                        id={'acceptInviteHeadingCommon'}
                        defaultMessage={'Join {company} on {admin}'}
                        values={{ company: inviter_resource_name, admin: admin_name }}
                    />
                );
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { forceChangePassword } = nextProps;
        if (forceChangePassword) {
            this.setState({ ...this.state, form: 'change-password' });
        }
    }

    render() {
        let form = this.state.form ? this.state.form : this.props.form;
        const { location } = this.props;
        const inviteInfo = parseQueryString(location ? location.search : {});

        return (
            <div className="account-page">
                <style type="text/css">{`body { background-color: #dedede; }}`}</style>
                <div className="container-fluid">
                    {form !== 'accept-invite' ? (
                        <div className="account-content col-xs-12 col-sm-6 col-sm-offset-3 col-md-4 col-md-offset-4">
                            <div className="col-xs-12 heading">
                                <div className="logo no-select">
                                    <span className="green">Green</span>
                                    <span className="light">Light</span>
                                </div>
                                <div className="tagline no-select">
                                    <FormattedMessage id={'tagline'} defaultMessage={'Paying The World’s Independent Workforce'} />
                                </div>
                            </div>
                            <div className="col-xs-12">{this.renderForm()}</div>
                        </div>
                    ) : (
                        <div className="account-content col-xs-12 col-md-6 col-md-offset-3">
                            {inviteInfo.invitee_role !== 'witness' && (
                                <div className="col-xs-12 heading accept-invite-heading">{this.getAcceptInviteHeading(inviteInfo)}</div>
                            )}
                            <div className="col-xs-12 accept-witness-invite-box">{this.renderForm(inviteInfo)}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    forceChangePassword: state.identity.forceChangePassword,
    session: state.identity.session
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            login: login,
            changePassword: changePassword,
            forgotPassword: forgotPassword,
            resetPassword: resetPassword,
            acceptInvite: acceptInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AccountPage);



// WEBPACK FOOTER //
// ./src/pages/account/index.jsx